export enum ComposedTitles {
  CAML_URB_ESTAC__EMEL_ID = 30007669,
  CAML_URB_ESTAC__EMPARQUE_ID = 30007670
}
